<style scoped lang="less" src="./index.less"></style>
<template>
  <div>
    <div class="mask" v-show="showMask" @touchstart="handleClickHideMask"></div>
    <!-- 支付列表弹窗 -->
    <div class="payBox" v-show="showMask" :class="[showPayBox ? 'animated show':'animated hide']">
      <p class="title">
        快问医生
      </p>
      <!--<p class="price">￥{{price}}</p>-->
      <ul class="payInfo">
        <li>
          <span class="title">
            待支付金额
          </span>
          <span class="price">
            <template v-if="paywayid === 16">
              {{price < 0 ? 0 : Number(price).toFixed(2)}}树币
            </template>
            <template v-else>
              ￥{{price < 0 ? 0 : Number(price).toFixed(2)}}
            </template>
          </span>
        </li>
        <li>
          <span class="title">支付方式</span>
          <template v-if="paywayid === 1 || paywayid === 4">
            <span class="payWay" :class="{select: paywayid === 1}" @click="selectPayWay(1)">
              <font class="mayi">
                支付宝
              </font>
            </span>
              <span class="payWay" :class="{select: paywayid === 4}" @click="selectPayWay(4)">
              <font class="wx">
                微信支付
              </font>
            </span>
          </template>
          <span v-if="paywayid === 16" class="shubiText">树币 余额{{shubiBalance}}</span>
          <i v-if="!(supportShubi && ios)" class="right-arrow" @click="choosePayWay"></i>
        </li>
      </ul>
      <div class="btn">
        <a href="javascript:;" data-track="djk-kj-lessons_payment_submit" class="buy" @click='handleClickToPay'>{{buyBtnText}}</a>
      </div>
    </div>

    <div class="paySelect" v-if="paySelect">
      <p class="title">选择支付方式</p>
      <ul>
        <li class="thinner-border" @click="selectPayWay(item.paywayid, index)"
            v-for="(item, index) in payWayList" :key="index">
          <template v-if="item.paywayid !== 16">
            <span class="payWay" :class="{select: item.paywayid === paywayid}">
              <font :class="item.className">
                {{item.title}}
              </font>
            </span>
          </template>
          <template v-else>
            <template v-if="shubiBalance > 0">
              <span class="payWay" :class="{select: item.paywayid === paywayid}">
                <font :class="item.className">
                  {{item.title}}
                </font>
              </span>
              <strong>余额￥{{shubiBalance}}</strong>
            </template>
            <template v-else>
              <!--树币余额不足-->
              <span class="payWay noselect">
                <font :class="item.className" class="noshubi">
                  {{item.title}}
                </font>
              </span>
            </template>
          </template>
        </li>
      </ul>
    </div>

    <!-- 页面loading -->
    <loading />
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import Loading from '../Loading';
  import doLogin from '../../lib/do-login';
  import {os} from '@/lib/ua';

  export default {
    name: 'PayComp',    // 奖学金支付组件
    components: {
      Loading
    },
    props: ['oldPrice', 'orderCode'],
    data() {
      return {
        showPayBox: false,
        showMask: false,
        paySelect: false,
        isInH5: false,
        showResult: false,
        buyCourseInfo: null,
        usePoint: false,
        buyInfo: null,
        paywayid: 1,
        shubiBalance: 0 // 树币余额
      };
    },
    computed: {
      ...mapState([
        'memberState', 'goodsVipInfo'
      ]),
      supportShubi() {
        const curserVersion = doLogin.getAppVersion();
        return window.isApp === 1 && curserVersion > 239;
      },
      isApp() {
        return Boolean(window.isApp);
      },
      canPayShubi() {
        // 树币余额是否充足
        return this.shubiBalance >= this.price;
      },
      buyBtnText() {
        // 树币余额不足 且 支付方式是树币
        return !this.canPayShubi && os.ios && this.paywayid === 16 ? '余额不足，立即充值' : '立即支付';
      },
      payWayList() {
        const list = [
          {
            title: '支付宝支付',
            paywayid: 1,
            className: 'mayi'
          },
          {
            title: '微信支付',
            paywayid: 4,
            className: 'weixin'
          },
          {
            title: '树币余额',
            paywayid: 16,
            className: 'shubi'
          }
        ];
        return list;
      },
      price() {
        return this.memberState && this.goodsVipInfo && Number(this.goodsVipInfo.skuBenefitType) === 1 ? this.goodsVipInfo.otherPrice : this.oldPrice;
      },
      ios() {
        return os.ios;
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
      // 显示支付弹窗
      handleClickShowPayBox() {
        console.log('显示支付弹框');
        window.Track.doPublicTracker(1, {
          trackerCode: 'djk_kwyszftc_01',
          url: 'djk_kwyszftc'
        });
        if (this.supportShubi) {
          this.$store.dispatch('setLoading', true);
          window.MT.getShubiCount();
          window.queryShubiCallback = (code, msg, balance) => {
            this.$store.dispatch('setLoading', false);
            this.showMask = true;
            this.showPayBox = true;
            if (Number(code) === 0) {
              this.shubiBalance = balance;
              if (!this.canPayShubi && os.ios && this.paywayid === 16) {
                window.Track.doPublicTracker(1, {
                  trackerCode: 'djk_kwyszftc_02',
                  url: 'djk_kwyszftc'
                });
              } else {
                window.Track.doPublicTracker(1, {
                  trackerCode: 'djk_kwyszftc_03',
                  url: 'djk_kwyszftc'
                });
              }
            } else {
              this.$dialog.Toast({mes: msg});
            }
          };
          if (os.ios) {
            // IOS 平台默认树币支付
            this.paywayid = 16; // 默认树币支付
          }
        } else {
          this.showMask = true;
          this.showPayBox = true;
        }
      },
      // 隐藏支付弹窗
      handleClickHideMask() {
        if (this.showPayBox) {
          this.showPayBox = false;
          this.$store.dispatch('setLoading', false);
          setTimeout(() => {
            this.showMask = false;
            this.showResult = false;
          }, 350);
        } else if (this.paySelect) {
          this.showPayBox = true;
          this.paySelect = false;
        } else {
          this.showPayBox = false;
          this.paySelect = false;
          this.showMask = false;
        }
        if (this.supportShubi) {
          window.MT.dismissRecharge();
        }
      },
      choosePayWay() {
        if (os.ios && this.supportShubi) { // 如果是新版ios ，无法选择支付方式
          return;
        }
        this.showPayBox = false;
        this.paySelect = true;
        window.Track.doPublicTracker(1, {
          url: 'djk_kwyszffs',
          trackerCode: 'djk_kwyszffs_01'
        });
      },
      // 点击支付
      handleClickToPay() {
        if (!window.token) {
          this.$dialog.Confirm({
            mes: '您还未登录无法支付',
            opts: [
              {
                txt: '去登录',
                color: false,
                callback: () => {
                  doLogin.login(this.$route.query.code, this.getWxAuth);
                }
              }
            ]
          });
        }
        if (this.supportShubi) {
          // 树币充值
          if (!this.canPayShubi && os.ios && this.paywayid === 16) { // 树币余额不足，需要树币充值
            this.showPayBox = false;
            const needPay = this.price - this.shubiBalance;
            window.MT.showRecharge({
              payNumber: needPay,
              type: 2 // 奖学金计划：type=1，快问医生：type = 2
            });
            window.hideRechargeNative = () => {
              this.handleClickShowPayBox();
            };
            window.rechargeResultNative = (type) => {
              if (type === 1) {
                window.MT.getShubiCount();
                this.handleClickShowPayBox();
              } else {
                this.$dialog.Toast({mes: '充值失败'});
              }
            };
            window.Track.doPublicTracker(2, {
              trackerCode: 'djk_kwyszftc_02',
              url: 'djk_kwyszftc'
            });
            return;
          }
          // 立即支付
          this.$store.dispatch('orderPay', {
            ordercode: this.orderCode,
            paywayid: this.paywayid,
            singleWap: 1
          }).then((v) => {
            if (v.data) {
              if (this.paywayid === 16) {
                this.$store.dispatch('setLoading', true);
                window.MT.bigHealthShubiPayMethod(JSON.stringify(v));
                window.shubiPayCallback = (code, msg) => {
                  this.$store.dispatch('setLoading', false);
                  this.showPayBox = false;
                  this.paySelect = false;
                  this.showMask = false;
                  this.payResult(Number(code) === 0, msg);
                };
              } else if (this.paywayid === 4 || this.paywayid === 1) {
                window.MT.gotoPayWithPaywayid(this.orderCode, this.paywayid);
              } else {
                this.$dialog.Toast({mes: '请选择正确的支付方式'});
              }
            }
          });
          window.Track.doPublicTracker(2, {
            trackerCode: 'djk_kwyszftc_03',
            url: 'djk_kwyszftc'
          });
        }
      },
      // 选择支付方式
      selectPayWay(paywayid, index) {
        if (!this.canPayShubi && paywayid === 16) { // 树币余额不足，不能选择树币
          return;
        }
        this.paywayid = paywayid;
        this.paySelect = false;
        this.showPayBox = true;
        window.Track.doPublicTracker(2, {
          url: 'djk_kwyszffs',
          trackerCode: 'djk_kwyszffs_02',
          item_posv: index + 1
        });
      },
      changeStatus() {
      },
      goToPay() {
      },
      goToPayResult() {
      },
      payResult(status, msg) {
        this.$emit('paySuccess', status, msg);
      },
      // 微信授权
      getWxAuth() {
        this.$store.dispatch('wxAuth', {
          code: this.$route.query.code,
          platformType: 5
        }).then((v) => {
          if (v.rescode.code === '0') {
            const userInfo = v.user[0];
            userInfo.weixinUserInfo = v.weixinUserInfo;
            doLogin.info(JSON.stringify(userInfo), userInfo.token); // 存储授权成功后的信息
            window.token = userInfo.token;
            this.$store.dispatch('setToken', userInfo.token);
            window.ajaxHeader.token = userInfo.token;
            this.$store.dispatch('setLoading', true);
            this.getUserMemberInfo();
          } else {
            this.$dialog.Toast({mes: v.rescode.info});
          }
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// index.vue?66eb39eb